import { Button, Flex, FlexProps } from "@chakra-ui/react"
import { useRouter } from "next/compat/router"
import { useInstantSearch } from "react-instantsearch-core"

interface IShowMoreProps extends FlexProps {
  showMore: () => void
  isHome: boolean
}

const ShowMore = ({ showMore, isHome }: IShowMoreProps) => {
  const { status } = useInstantSearch()
  const router = useRouter()
  return (
    <Flex justifyContent={"center"}>
      {isHome ? (
        <Button
          onClick={() => router?.push("/s")}
          mt={8}
          size={"sm"}
          bgColor={"yellow.400"}
          _hover={{
            bgColor: "yellow.500",
          }}
          _active={{
            bgColor: "yellow.500",
          }}
          color={"black"}
          px={10}
          py={5}
        >
          {"See More Results"}
        </Button>
      ) : (
        <Button
          onClick={showMore}
          mt={8}
          size={"sm"}
          bgColor={"yellow.400"}
          _hover={{
            bgColor: "yellow.500",
          }}
          _active={{
            bgColor: "yellow.500",
          }}
          color={"black"}
          px={10}
          py={5}
          isLoading={status === "loading" || status === "stalled"}
          loadingText={"Loading ..."}
        >
          {"Show More"}
        </Button>
      )}
    </Flex>
  )
}

export default ShowMore
